import moment from 'moment'

function plugin(Vue) {
    if (Vue && Vue.filter) {

        // filter to limit content to 100 strs
        Vue.filter('cut', value => value.length >= 100 ? value.substring(0, 100) + '...' : value)

        Vue.filter('cut_len', (value,ilen) => {
            if (!value) {
                return ''
            }
            return value.length > ilen ? value.substring(0, ilen) + '...' : value
        })


        // format date from iso8601 string
        Vue.filter('formatDateByIso', value => {
            return value && moment(value).format('YYYY-MM-DD HH:mm:ss')
        })

        Vue.filter('addtime', (value, type) => {
            return value && value + (!type ? ' 00:00:00' : ' 24:00:00')
        })

        // format price 22 => 22.00
        Vue.filter('priceformat', value => Number(value).toFixed(2))

        Vue.filter("url",function(value){
            if (arguments.length>1){
                var reg = /\/$/;
                if(reg.test(value)==false){
                    value = value+"/";
                }
                var url = value;
                var ilen = arguments.length;
                for(var i= 1;i<ilen;i++){
                    if(i<ilen-1){
                        url += arguments[i]+"/";
                    }else{
                        url += arguments[i];
                    }

                }
                return url;
            }
            return  value;
        });

        Vue.filter("truncatechars",function(value, count){
            const str = value
            const reg = /[^\u0000-\u00ff]/
            let resStr = ""
            let resCount = 0
            if (!count || str.length <= count) {
                return str
            }
            for (let i = 0; i < str.length; i++) {
                const iStr = str[i]
                if (reg.test(iStr)) {
                    resCount += 1;
                } else {
                    resCount += 0.5;
                }
                resStr += iStr
                if (resCount >= count) {
                    return `${resStr}...`
                }
            }
            return str;
        });

        Vue.filter("date",function(value,format_s){
            if (format_s=="H:i Y-m-d"){
                return value && moment(value).format('HH:mm YYYY-MM-DD')
            }else if(format_s){
                return value && moment(value).format(format_s);
            }
            return value;

        });
        Vue.filter("time",function(value,format_s){
            if (format_s=="H:i"){
                return value && moment(value).format('HH:mm')
            }else if(format_s){
                return value && moment(value).format(format_s);
            }
            return value;

        });

        // 问答详情页(qaitem.vue)过滤函数：将数组arr1(教师的回答)中出
        // 现的arr2(已经偷看过的回答)中的相同id的元素去除后返回
        Vue.filter("yankOut",function(arr1,arr2){
            let tempArr = []
            for (let i = 0; i < arr1.length; i++) {
                tempArr.push(arr1[i].id)
            };
            for (let i = 0; i < arr2.length; i++) {
                let j = tempArr.indexOf(arr2[i])
                if(j > -1){
                    arr1.splice(j,1)
                }
            };
            return arr1;
        });

        Vue.filter("scorepreci",function(score, defaultStr) {
            if (+score) {
                return (score/100).toFixed(1).replace(/\.0$/, '')
            }
            return defaultStr || score
        });
    }
}

if (typeof define === 'function' && define.amd){
    // AMD. Register as an anonymous module.
    define(['exports'], function(){
        return plugin;
    });
}

export default plugin



// WEBPACK FOOTER //
// ./src/util/vue-filter.js